/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsAddCatalogEntry } from "../../funcs/llmModelsAddCatalogEntry.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.AddCatalogModelRequest$inboundSchema,
};

export const tool$llmModelsAddCatalogEntry: ToolDefinition<typeof args> = {
  name: "llm-models-add-catalog-entry",
  description: `Define a BYO catalog model

Creates an API-owned BYO definition without activating its name.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsAddCatalogEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
